/**
 * Testimonial Slider
 */

jQuery(function ($) {
$('.testimonial-slider .centered .slides').slick({
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    });
});
